/**
 * This utility function helps with the pattern of having prop that can be
 * either a function or some arbitrary type.
 *
 * Useful for props and hook parameters
 *
 * @param maybeFn Object to test if is function
 * @param args Arguments passed to {@linkcode maybeFn} if it is a function
 */
export function invokeOrReturn<MaybeFunction>(
  maybeFn: MaybeFunction,
  args: MaybeFunction extends (...p: any) => any
    ? Parameters<MaybeFunction>
    : never,
): MaybeFunction extends (...args: any) => infer ReturnType
  ? ReturnType
  : MaybeFunction {
  return typeof maybeFn === 'function'
    ? maybeFn(...args)
    : // Casting to any here is fine because the function return is typed
      (maybeFn as any);
}
